import DbConfig from '../../../config/DbConfig.js'
import {formatTimeToYMDHms,socketType2DbType,trim} from '../../functions/Common.js'

// 根据群id，客服id，获取群聊天列表
export function getClusterRecordListByClusterId(clusterId,cOpenId,firstId,callback){
	let db = DbConfig.connect()
	let sql = 'select id,from_wx_id as from_id,from_nickname as from_name,from_photo,to_wx_id as to_id,wechat_cluster_id,content,send_time,is_send,type,pic_thumb from yswl_cluster_chat_record '
	sql += 'where cluster_id = '+ clusterId + ' and to_wx_id= "' + cOpenId + '"'
	if(firstId != 0){
		sql += ' and id < ' + firstId
	}
	sql += ' order by id desc limit 20'
	db.transaction(tx=>{
		tx.executeSql(sql,[],(tx,results)=>{ 
			let list = []
			for(let i = 0;i < results.rows.length;i++){
				let temp_data = results.rows[i];
				temp_data.is_me = results.rows[i].from_id == cOpenId?1:0
				list.push(temp_data)
			}
			callback(list)
		})
	})
}

// 根据粉丝id，获取聊天记录
export function getClusterRecordListByFansIdAndType(clusterId,type,callback){
	if(type === undefined || type === ''){
		type = 'text'
	}
	let db = DbConfig.connect()
	let sql = 'select id,content from yswl_cluster_chat_record where cluster_id = '+ clusterId + ' and type = "' + type + '" order by id asc'
	db.transaction(tx=>{
		tx.executeSql(sql,[],(tx,results)=>{ 
			let list = []
			for(let i = 0;i < results.rows.length;i++){
				list.push(results.rows[i])
			}
			callback(list)
		})
	})
}

/**
 * 保存群信息到本地，包括接收和发送
 * @param {Object} data
 * @param {Object} callback
 * data格式：
 * 	content: "122121"
 *	friendId: 127
 *  clusterName:'PHP交流群'
 *  clusterImg: "/uploads/cluster_images/20200821/1597992444835.jpg"
 *	fromId: "23661295916@chatroom"
 *	mOpenId: "wxid_b5s47uvon6k622"
 *	mPhoto: "http://wx.qlogo.cn/mmhead/ver_1/xuLxb1v3AeCxGFIg7hiceaslYlRkTjUOnvnA6mqcVm1ic0BiaxGSP68p8fTA1ufTh6ZvyJzEbk14frp7ClQM0eNKIu58RHjrwK2VLaicwVWBGzc/96"
 *	mWxName: "爱我所爱"
 *	msgType: "2"
 *	recentlyId: 13668
 *	recodeId: 358
 *	time: 1598246758676
 *	toId: "wxid_ha32embhveox22"
 *	type: "_Text"
 */
export function saveClusterMsg(data,callback){
	let db = DbConfig.connect()
	let id = data.recodeId
	let cluster_id = data.friendId
	let from_wx_id = data.mOpenId
	let wechat_cluster_id = data.fromId
	let from_nickname = data.mWxName
	let from_photo = data.mPhoto
	let wechat_cluster_name = data.clusterName
	let to_wx_id = data.toId
	let content = data.content
	let send_time = formatTimeToYMDHms(data.time)
	let is_send = data.is_send === undefined ? 1 : data.is_send
	let type = socketType2DbType(data.type)
	let msgId = 0
	let pic_thumb = ''
	let sql = 'insert into yswl_cluster_chat_record(id,cluster_id,from_wx_id,wechat_cluster_id,from_nickname,from_photo,wechat_cluster_name,to_wx_id,content,send_time,is_send,type,msgId,pic_thumb) values(?,?,?,?,?,?,?,?,?,?,?,?,?,?)'
	db.transaction(tx=>{
		tx.executeSql(sql,[id,cluster_id,from_wx_id,wechat_cluster_id,from_nickname,from_photo,wechat_cluster_name,to_wx_id,content,send_time,is_send,type,msgId,pic_thumb],(tx,results)=>{ 
			callback(true)
		},(tx,error)=>{
			console.log(error)
		})
	})
}

// 根据id，获取记录详情
export function getClusterRecordById(id,callback){
	let db = DbConfig.connect()
	let sql = 'select * from yswl_cluster_chat_record where id = '+ id
	db.transaction(tx=>{
		tx.executeSql(sql,[],(tx,results)=>{ 
			let info = {}
			if(results.rows.length  > 0){
				info = results.rows[0]
			}
			callback(info)
		})
	})
}

// 根据id，更新聊天记录
export function updateClusterRecordById(id,data,callback){
	let db = DbConfig.connect()
	let sql = 'update yswl_cluster_chat_record'
	if(data.is_send !== undefined){
		sql += ' set is_send = '+ data.is_send + ','
	}
	if(data.type !== undefined){
		sql += ' set type = "'+ data.type + '",'
	}
	if(data.content !== undefined){
		sql += ' content = "'+ data.content + '",'
	}
	sql = trim(sql,',')
	sql += ' where id = '+ id
	db.transaction(tx=>{
		tx.executeSql(sql,[],(tx,results)=>{ 
			callback(true)
		},(tx,error)=>{
			console.log(error)
			callback(false)
		})
	})
}

// 根据群id，客服id，数量，获取群聊天列表
export function getClusterRecordListByClusterIdAndNum(clusterId,cOpenId,num,callback){
	let db = DbConfig.connect()
	let sql = 'select id,from_wx_id as from_id,from_nickname as from_name,from_photo,to_wx_id as to_id,wechat_cluster_id,content,send_time,is_send,type,pic_thumb from yswl_cluster_chat_record '
	sql += 'where cluster_id = '+ clusterId + ' and to_wx_id= "' + cOpenId + '" order by id desc limit '+num
	db.transaction(tx=>{
		tx.executeSql(sql,[],(tx,results)=>{ 
			let list = []
			for(let i = 0;i < results.rows.length;i++){
				let temp_data = results.rows[i];
				temp_data.is_me = results.rows[i].from_id == cOpenId?1:0
				list.push(temp_data)
			}
			callback(list)
		})
	})
}


// 根据id，删除聊天记录
export function deleteClusterRecordById(id,callback){
	let db = DbConfig.connect()
	let sql = 'delete from yswl_cluster_chat_record where id = '+ id
	db.transaction(tx=>{
		tx.executeSql(sql,[],(tx,results)=>{ 
			callback(true)
		})
	})
}